<section class="hd-love-gates-cheat-sheet-page">
  <!-- Controls -->
  <e-card2 class="hd-love-gates-cheat-sheet-page__controls-card" padding="2">
    <div class="hd-love-gates-cheat-sheet-page__controls" aria-label="Love gates cheat sheet controls">
      <e-hd-content-language-picker></e-hd-content-language-picker>

      <span class="hd-love-gates-cheat-sheet-page__divider"></span>

      <button type="button" class="hd-love-gates-cheat-sheet-page__control" (click)="print()" aria-label="Print de cheat sheet">
        <i eIcon icon="print"></i>
        <span>Print</span>
      </button>
    </div>
  </e-card2>

  @if (title()) {
    <h2 class="hd-love-gates-cheat-sheet-page__title">
      {{ title() }}
      @if (titleSuffix()) {
        <span class="hd-love-gates-cheat-sheet-page__title-suffix">{{ titleSuffix() }}</span>
      }
    </h2>
  }

  <div class="hd-love-gates-cheat-sheet-page__deck">
    <div class="hd-love-gates-cheat-sheet-page__columns">
      <!-- Linkerkolom: algemene tekst + kaarten 10/15/44/28 + quote + 58 -->
      <div class="hd-love-gates-cheat-sheet-page__column">
        <div class="hd-love-gates-cheat-sheet-page__general">
          @if (generalHeading()) {
            <h3 class="hd-love-gates-cheat-sheet-page__general-heading">{{ generalHeading() }}</h3>
          }
          @for (paragraph of generalParagraphs(); track $index) {
            <p class="hd-love-gates-cheat-sheet-page__paragraph">{{ paragraph }}</p>
          }
          @if (generalQuote()) {
            <p class="hd-love-gates-cheat-sheet-page__quote">
              {{ generalQuote() }} <span class="hd-love-gates-cheat-sheet-page__quote-author">{{ generalQuoteAuthor() }}</span>
            </p>
          }
          @for (paragraph of generalParagraphs2(); track $index) {
            <p class="hd-love-gates-cheat-sheet-page__paragraph">{{ paragraph }}</p>
          }
        </div>

        @for (gate of leftTopGates; track gate) {
          <hd-love-cheat-card [gate]="gate" />
        }

        @if (quoteLeft()) {
          <p class="hd-love-gates-cheat-sheet-page__quote hd-love-gates-cheat-sheet-page__quote--standalone">{{ quoteLeft() }}</p>
        }

        <hd-love-cheat-card [gate]="leftBottomGate" />
      </div>

      <!-- Middenkolom: mandala-ring, reflectievragen, bodygraph-fragmenten -->
      <div class="hd-love-gates-cheat-sheet-page__column hd-love-gates-cheat-sheet-page__column--center">
        <img
          class="hd-love-gates-cheat-sheet-page__ring"
          [src]="mandalaRingAsset"
          [alt]="title()" />

        @if (reflectionQuestions().length > 0) {
          <div class="hd-love-gates-cheat-sheet-page__reflection">
            <h3 class="hd-love-gates-cheat-sheet-page__reflection-title">{{ reflectionTitle() }}</h3>
            <ul class="hd-love-gates-cheat-sheet-page__reflection-list">
              @for (question of reflectionQuestions(); track $index) {
                <li class="hd-love-gates-cheat-sheet-page__reflection-item">{{ question }}</li>
              }
            </ul>
          </div>
        }

        <img
          class="hd-love-gates-cheat-sheet-page__chart"
          [src]="chartAsset"
          alt="Bodygraph met de liefdespoorten" />
      </div>

      <!-- Rechterkolom: poortgroepen + kaarten 25/46/40/55 + quote + 41 -->
      <div class="hd-love-gates-cheat-sheet-page__column">
        <div class="hd-love-gates-cheat-sheet-page__groups">
          @for (group of groups(); track group.key) {
            <div class="hd-love-gates-cheat-sheet-page__group">
              <h3 class="hd-love-gates-cheat-sheet-page__group-title">
                <span class="hd-love-gates-cheat-sheet-page__group-gates">{{ group.gates }}</span>
                {{ group.title }}
              </h3>
              @if (group.lead) {
                <p class="hd-love-gates-cheat-sheet-page__group-lead">{{ group.lead }}</p>
              }
              @for (paragraph of group.paragraphs; track $index) {
                <p class="hd-love-gates-cheat-sheet-page__paragraph">{{ paragraph }}</p>
              }
            </div>
          }
        </div>

        @for (gate of rightTopGates; track gate) {
          <hd-love-cheat-card [gate]="gate" />
        }

        @if (quoteRight()) {
          <p class="hd-love-gates-cheat-sheet-page__quote hd-love-gates-cheat-sheet-page__quote--standalone">{{ quoteRight() }}</p>
        }

        <hd-love-cheat-card [gate]="rightBottomGate" />
      </div>
    </div>
  </div>
</section>
